import styled from 'styled-components';

export const DonutChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme, $dark }) => $dark ? '24px' : theme.spacing.lg};
    padding: ${({ theme }) => theme.spacing.sm} 0;
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 250px;
    margin-top: ${({ $dark }) => $dark ? '14px' : '0'};
    overflow: visible !important; /* Allow segments to extend on hover */

    @media (max-width: 1024px) {
        gap: ${({ theme, $dark }) => $dark ? '20px' : theme.spacing.md};
        min-height: 220px;
    }

    @media (max-width: 768px) {
        gap: ${({ theme, $dark }) => $dark ? '16px' : theme.spacing.sm};
        min-height: 180px;
    }

    @media (max-width: 480px) {
        flex-direction: column;
        align-items: center;
        gap: ${({ theme, $dark }) => $dark ? '12px' : theme.spacing.sm};
        min-height: 150px;
    }
`;

export const DonutChartWrapper = styled.div`
    position: relative;
    width: 260px;
    height: 260px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    overflow: visible !important; /* Allow slices to extend on hover */
    z-index: 1;
    
    @media (max-width: 1024px) {
        width: 220px;
        height: 220px;
    }

    @media (max-width: 768px) {
        width: 180px;
        height: 180px;
    }

    @media (max-width: 480px) {
        width: 150px;
        height: 150px;
    }
    
    /* Ensure SVG and all children can overflow */
    svg {
        overflow: visible !important;
    }
    
    * {
        overflow: visible !important;
    }
`;

export const DonutChartLabel = styled.div`
    font-family: var(--font-family-lufga);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    text-align: center;
    pointer-events: none;
    line-height: 1.3;
    opacity: 0;
    animation: fadeIn 0.5s ease-out 1.2s forwards;
    
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    
    div:first-child {
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: ${({ $dark }) => {
        // Always white text for Top Performing section
        return $dark ? '#FFFFFF' : '#ffffff';
    }};
        margin-bottom: 4px;

        @media (max-width: 1024px) {
            font-size: 13px;
        }

        @media (max-width: 768px) {
            font-size: 12px;
        }

        @media (max-width: 480px) {
            font-size: 11px;
        }
    }
    
    div:last-child {
        display: block;
        font-size: 24px;
        font-weight: 700;
        color: ${({ $dark }) => {
        // Always white text for Top Performing section
        return $dark ? '#FFFFFF' : '#ffffff';
    }};

        @media (max-width: 1024px) {
            font-size: 20px;
        }

        @media (max-width: 768px) {
            font-size: 18px;
        }

        @media (max-width: 480px) {
            font-size: 16px;
        }
    }
`;

export const DonutChartLegend = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    padding: 40px 24px;
    align-items: flex-end;

    @media (max-width: 1024px) {
        padding: 30px 20px;
    }

    @media (max-width: 768px) {
        padding: 24px 16px;
    }

    @media (max-width: 480px) {
        align-items: center;
        padding: 16px 0;
        width: 100%;
    }
`;

export const DonutChartLegendItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 210px;

    @media (max-width: 768px) {
        max-width: 100%;
    }
`;

export const DonutChartLegendTopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 60px;
`;

export const DonutChartLegendLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
`;

export const DonutChartLegendBar = styled.div`
    width: 4px;
    height: 14px;
    background: ${({ $color }) => $color};
    border-radius: 2px;
    flex-shrink: 0;
`;

export const DonutChartLegendLabel = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: ${({ $isEnterprise, $dark }) => {
        if ($isEnterprise) {
            return $dark ? '#FFFFFF' : '#FFFFFF';
        }
        return $dark ? '#FFFFFF' : '#FFFFFF';
    }};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DonutChartLegendValue = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${({ $dark }) => {
        return $dark ? '#FFFFFF' : '#FFFFFF';
    }};
`;

export const DonutChartLegendPercentage = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    background: #393939;
    padding: 2px 8px;
    border-radius: 5px;
    white-space: nowrap;
    flex-shrink: 0;
`;

// Shipment Statistics Chart Styles
export const ShipmentChartCard = styled.div`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#292929' : '#ffffff';
    }};
    border-radius: 16px;
    border: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return `1px solid ${isDark ? '#2C2C2C' : '#E5E5E5'}`;
    }};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    // padding: 24px;
    padding: 24px 24px 12px 24px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 20px;
        border-radius: 12px;
    }

    @media (max-width: 480px) {
        padding: 16px;
        border-radius: 10px;
    }
`;

export const ShipmentChartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        margin-bottom: 16px;
    }

    @media (max-width: 480px) {
        margin-bottom: 12px;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
`;

export const ShipmentChartTitle = styled.h3`
    font-size: 24px;
    font-weight: 600;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
    font-family: var(--font-family-figtree);
    margin: 0;
    padding-bottom: 0;

    @media (max-width: 768px) {
        font-size: 20px;
    }

    @media (max-width: 480px) {
        font-size: 18px;
    }
`;

export const ShipmentChartDropdown = styled.div`
    .ant-select {
        .ant-select-selector {
            border-radius: 8px;
            border: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return `1px solid ${isDark ? '#2C2C2C' : '#E5E5E5'}`;
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#1F1F1F' : '#ffffff';
    }};
        }
    }
`;

export const ShipmentChartLegend = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 0;
`;

export const ShipmentChartLegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ShipmentChartLegendSquare = styled.div`
    width: 14px;
    height: 14px;
    background-color: ${({ $color }) => $color};
    border-radius: 2px;
    flex-shrink: 0;
`;

export const ShipmentChartLegendLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
    font-family: var(--font-family-figtree);
`;

export const ShipmentChartContainer = styled.div`
    width: calc(100% + 48px);
    flex: 1;
    min-height: 0;
    position: relative;
    background: transparent;
    margin-left: -24px;
    margin-right: -24px;
    padding-right: 24px;

    /* Remove background bar overlay on hover - hide activeBar completely */
    .recharts-active-bar,
    .recharts-active-bar *,
    .recharts-bar-background-rectangle,
    .recharts-active-bar rect,
    .recharts-active-bar .recharts-bar-rectangle {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        fill: transparent !important;
        stroke: transparent !important;
        pointer-events: none !important;
    }

    /* Hide any background rectangles that Recharts creates behind bars */
    svg .recharts-bar-background-rectangle,
    svg .recharts-active-bar,
    svg .recharts-active-bar rect,
    svg .recharts-active-bar path {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        fill: transparent !important;
        stroke: transparent !important;
    }

    /* Prevent background overlay on bar hover - target all rect elements behind bars */
    .recharts-bar:hover ~ .recharts-bar-background-rectangle,
    .recharts-bar:hover .recharts-bar-background-rectangle,
    .recharts-bar:hover + .recharts-bar-background-rectangle {
        display: none !important;
        opacity: 0 !important;
        fill: transparent !important;
    }

    /* Target all possible background elements */
    g.recharts-active-bar,
    g.recharts-active-bar > * {
        display: none !important;
        opacity: 0 !important;
    }

    @media (max-width: 1024px) {
        height: 350px;
        min-height: 350px;
        flex: none;
    }

    @media (max-width: 768px) {
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-right: -20px;
        padding-left: 20px;
        padding-right: 20px;
        height: 280px;
        min-height: 280px;
        flex: none;
    }

    @media (max-width: 480px) {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-right: -16px;
        padding-left: 16px;
        padding-right: 16px;
        height: 240px;
        min-height: 240px;
        flex: none;
    }
`;

